import React, { Component } from "react";
import { Container, Col, Row, Media, Button } from "reactstrap";

import WidgetView2 from "./w2";


export default class WidgetSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGeo: "County:Santa Clara",
      geo: ["County:Santa Clara"]
    };
    this._onGeoSelect = this._onGeoSelect.bind(this);

  }
  _onGeoSelect(e) {
    var selectedGeo = e.target.value;  
    var geo = this.state.geo;
    selectedGeo.toLowerCase() == "santa clara"
      ? (geo = ["County:Santa Clara"])
      : selectedGeo.toLowerCase() == "santa cruz"
        ? (geo = ["County:Santa Cruz"])
        : selectedGeo.toLowerCase() == "san benito"
          ? (geo = ["County:San Benito"])
          : selectedGeo.toLowerCase() == "san mateo"
          ? (geo = ["County:San Mateo"])
          : selectedGeo.toLowerCase() == "monterey"
            ? (geo = ["County:Monterey"])
            : (geo = "");
    this.setState({
      selectedGeo,  
      
      geo
    });
  }



  render() {
    const assets = "";

    var selectGeovalue = (
      <select
        id="geo-select"
        className="custom-select w-50"
        value={this.state.selectedGeo}
        onChange={this._onGeoSelect}>
        <option key="1" value="Santa Clara">
        Santa Clara
        </option>
        <option key="2" value="Santa Cruz">
        Santa Cruz
        </option>
        <option key="3" value="San Benito">
        San Benito
        </option>
        <option key="4" value="San Mateo">
        San Mateo
        </option>
        <option key="5" value="Monterey">
        Monterey
        </option>
      </select>
    );

    return (
      <div className="widget-page full-height pos-relative">  
        <div className="bi-geoselection mb-0">
          {selectGeovalue}
        </div>

       
          <Container >  
                 
            <WidgetView2 geo={this.state.geo} />
          
          </Container>
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/WidgetSelection.js